import { useState } from "react";
import { Link } from "react-router";
import { buttonVariants } from "@heroui/react";
import { PlusIcon, BookOpenIcon } from "@heroicons/react/24/outline";
import { RecipesMenu } from "./RecipesMenu";
import { AvatarMenu } from "./AvatarMenu";
import { MobileMenu } from "./MobileMenu";

export const SiteHeader = () => {
    const [theme, setThemeState] = useState<"light" | "dark">(
        () => (document.documentElement.getAttribute("data-theme") as "light" | "dark") ?? "light"
    );

    const setTheme = (next: "light" | "dark") => {
        document.documentElement.classList.remove("light", "dark");
        document.documentElement.classList.add(next);
        document.documentElement.setAttribute("data-theme", next);
        setThemeState(next);
    };

    const handleToggleTheme = () => setTheme(theme === "light" ? "dark" : "light");

    return (
        <header className="sticky top-0 z-40 w-full bg-[var(--background)]/75 backdrop-blur-md backdrop-saturate-150">
            <nav
                aria-label="Primary"
                className="max-w-7xl mx-auto h-16 flex items-center justify-between gap-4 px-4 md:px-8"
            >
                <Link
                    to="/"
                    aria-label="Home — The Savory Grimoire"
                    className="flex items-center gap-3 shrink-0 min-w-0"
                >
                    <img src="/savorygrimoire-512.png" alt="" className="h-10 w-auto" />
                    <span className="font-display text-base md:text-lg tracking-[0.18em] uppercase text-primary-800 dark:text-default-50 max-w-min leading-tight sm:max-w-full sm:whitespace-nowrap sm:leading-normal">
                        The Savory Grimoire
                    </span>
                </Link>

                <div className="hidden md:flex items-center gap-6">
                    <RecipesMenu />
                    <Link
                        to="/recipes/new"
                        className="inline-flex items-center gap-1.5 font-EBGaramond text-lg italic text-default-700 hover:text-foreground transition-colors px-1 py-1.5"
                    >
                        <PlusIcon className="w-4 h-4" />
                        Add a Recipe
                    </Link>
                    <Link
                        to="/manage"
                        aria-label="Manage library"
                        title="Manage library"
                        className={`${buttonVariants({ variant: "ghost", size: "sm", isIconOnly: true })} text-default-700 hover:bg-mystic-100 hover:text-mystic-800 cursor-pointer`}
                    >
                        <BookOpenIcon className="w-5 h-5" />
                    </Link>
                    <AvatarMenu theme={theme} onToggleTheme={handleToggleTheme} />
                </div>

                <div className="flex md:hidden items-center">
                    <MobileMenu theme={theme} onToggleTheme={handleToggleTheme} />
                </div>
            </nav>
            <div
                aria-hidden="true"
                className="absolute inset-x-0 -bottom-px h-px bg-gradient-to-r from-transparent via-accent-500/35 to-transparent"
            />
        </header>
    );
};
